var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgPencil = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5118 1.48816L12.8654 1.1346V1.1346L12.5118 1.48816ZM3.33333 13.0237V13.5237C3.46594 13.5237 3.59312 13.471 3.68689 13.3772L3.33333 13.0237ZM1 13.0237H0.5C0.5 13.2998 0.723858 13.5237 1 13.5237V13.0237ZM1 10.6429L0.646447 10.2894C0.552678 10.3832 0.5 10.5103 0.5 10.6429H1ZM10.5083 1.84171C10.9639 1.3861 11.7026 1.3861 12.1583 1.84171L12.8654 1.1346C12.0192 0.288466 10.6474 0.288466 9.80123 1.1346L10.5083 1.84171ZM12.1583 1.84171C12.6139 2.29732 12.6139 3.03601 12.1583 3.49162L12.8654 4.19873C13.7115 3.3526 13.7115 1.98074 12.8654 1.1346L12.1583 1.84171ZM12.1583 3.49162L2.97978 12.6701L3.68689 13.3772L12.8654 4.19873L12.1583 3.49162ZM3.33333 12.5237H1V13.5237H3.33333V12.5237ZM9.80123 1.1346L0.646447 10.2894L1.35355 10.9965L10.5083 1.84171L9.80123 1.1346ZM0.5 10.6429V13.0237H1.5V10.6429H0.5ZM8.80123 2.84171L11.1583 5.19873L11.8654 4.49162L9.50834 2.1346L8.80123 2.84171Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPencil, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pencil.22c74dd4.svg";
export { ForwardRef as ReactComponent };